import { IApiReferral, IReferral } from '../interface/IReferreal'

export const referralTransformer = (apiReferral: IApiReferral): IReferral => ({
  referralCode: apiReferral.referral_code,
  referralLink: apiReferral.referral_link,
  total: apiReferral.total,
  list: apiReferral.list.map(item => ({
    uuid: item.uuid,
    referee: {
      establishment: {
        uuid: item.referee.establishment.uuid,
        name: item.referee.establishment.name,
      },
      person: {
        uuid: item.referee.person.uuid,
        fullName: item.referee.person.full_name,
      },
    },
    redeemedAt: item.redeemed_at,
  })),
})
